import { QxForm } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;
let cachedQxForms: QxForm[];

export const QxFormService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getQxForms = async (useCache: boolean = true): Promise<QxForm[]> => {
    if (useCache && cachedQxForms != null)
      return cachedQxForms;

    if (dotNetObj) {
      cachedQxForms = await dotNetObj.invokeMethodAsync<QxForm[]>('GetQxFormByWebUserAsync');
      return cachedQxForms;
    } else {
      throw 'QxForm DotNet Object Reference has not yet been implemented';
    }
  };

  const getQxFormsByCustomerSite = async (siteId: string, customerId?: string): Promise<QxForm[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<QxForm[]>('GetQxFormByCustomerSiteWebUserAsync', customerId, siteId);
    } else {
      throw 'QxForm DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getQxForms,
    getQxFormsByCustomerSite,
  };
})();
